export const unique = (values) => [...new Set(values)];

export const merge = (values) => values.reduce((merged, value) => [...merged, ...value]);
